import { LEGACY_RUNTIME_DISPATCH_POLICY, } from "@openmeld/schemas";
export const shouldDispatchForMentionOnly = (input) => {
    const triggerMode = input.triggerMode ?? LEGACY_RUNTIME_DISPATCH_POLICY;
    if (triggerMode === "listen_all") {
        return true;
    }
    return triggerMode === LEGACY_RUNTIME_DISPATCH_POLICY && input.mentioned;
};
